import React from "react";
import Checkbox from "../../Form/Checkbox";

interface CustomSelectItemProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  value: string;
  isChecked: boolean;
}

const CustomSelectItem = React.forwardRef<
  HTMLDivElement,
  CustomSelectItemProps
>(({ label, value, isChecked, ...others }, ref) => {
  return (
    <div
      ref={ref}
      {...others}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 12px",
        cursor: "pointer",
      }}
    >
      <Checkbox checked={isChecked} readOnly />
      <span>{label}</span>
    </div>
  );
});

CustomSelectItem.displayName = "CustomSelectItem";

export default CustomSelectItem;
